module.exports = __webpack_public_path__ + "static/launchpad-graphic-v2-8d28ba11c6430a053e44a55ff4f2b877.png";